/**
 * start.gg 連携の設定値（PoC）。機密でない値のみ。client_secret はサーバ側にのみ置く。
 *
 * 値はデプロイ環境の環境変数から注入する:
 * - REACT_APP_STARTGG_CLIENT_ID      OAuth アプリの client_id（例: 466）
 * - REACT_APP_STARTGG_REDIRECT_URI   start.gg 登録済みの callback（authorize/token交換で完全一致必須）
 * - REACT_APP_STARTGG_TOURNAMENT_SLUG 参加登録 iframe / entry 確認の対象大会 slug
 * - REACT_APP_STARTGG_EVENT_ID       entry 突合に使う対象イベントの Event.id
 */
export const startggConfig = {
  clientId: process.env.REACT_APP_STARTGG_CLIENT_ID ?? "",
  redirectUri: process.env.REACT_APP_STARTGG_REDIRECT_URI ?? "",
  tournamentSlug: process.env.REACT_APP_STARTGG_TOURNAMENT_SLUG ?? "",
  eventId: process.env.REACT_APP_STARTGG_EVENT_ID ?? "",
  authorizeEndpoint: "https://start.gg/oauth/authorize",
  scope: "user.identity",
} as const;

/** iframe に埋め込む start.gg 公式の登録フォーム URL */
export const startggRegisterEmbedUrl = (): string =>
  `https://start.gg/tournament/${startggConfig.tournamentSlug}/register/embed`;
